import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Contrast01 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "contrast01",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 2c.5917 0 1.1713.0514 1.7348.15M12 2C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10m0-20v20m5.738-18.191a10.0566 10.0566 0 0 1 2.4554 2.4564m1.6567 4.0002C21.9486 10.8289 22 11.4085 22 12c0 .5915-.0514 1.1711-.1499 1.7344m-1.6609 4.0062a10.056 10.056 0 0 1-2.4523 2.4511m-4.0041 1.6587A10.065 10.065 0 0 1 12 22"
    })
  }));
};
export default Contrast01;